export default {"src":"/_next/static/media/Footer Logo.02b837be.svg","height":40,"width":59,"blurWidth":0,"blurHeight":0};